"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function commaify(value) {
    if (typeof value === "number") {
        var str = value.toString();
        var _a = str.split('.'), integer = _a[0], decimal = _a[1];
        //add commas every 3 digits
        var integerDigits = integer.split('').reverse();
        var digitsWithCommas_1 = [];
        integerDigits.forEach(function (digit, index, array) {
            digitsWithCommas_1.push(digit);
            if (index != 0 && index % 3 == 2 && index != array.length - 1) {
                digitsWithCommas_1.push(',');
            }
        });
        var reverseBack = digitsWithCommas_1.reverse().join('');
        return reverseBack;
    }
    return value;
}
exports.commaify = commaify;
function parseCommaified(value) {
    var withoutCommas = value.replace(/,/g, '');
    return parseInt(withoutCommas, 10);
}
exports.parseCommaified = parseCommaified;
//# sourceMappingURL=Commaify.js.map